import React from 'react';
import RolloutStatusBadge from './RolloutStatusBadge';
import { getValidationSummaryText, modeLabelMap } from '../lib/recoveryRolloutFormatters';

const MODES = [
  'LEGACY_ONLY',
  'SHADOW_V2',
  'V2_PRIMARY_WITH_LEGACY_FALLBACK',
  'V2_ONLY',
];

const RecoveryModeChangePanel = ({
  currentMode,
  targetMode,
  setTargetMode,
  validationResult,
  onValidate,
  onChangeMode,
  validating,
  changing,
}) => {
  const canChange = Boolean(validationResult?.allowed) && !changing;

  const handleChangeMode = async () => {
    const confirmText = `Ubah mode rollout dari ${currentMode} ke ${targetMode}?`;
    if (!window.confirm(confirmText)) return;
    await onChangeMode?.();
  };

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Validasi Perubahan Mode</h3>

      <div className="mt-3 grid gap-3 xl:grid-cols-[1fr_auto_auto] xl:items-end">
        <label className="text-xs text-slate-300">
          Target Mode
          <select
            value={targetMode || ''}
            onChange={(e) => setTargetMode?.(e.target.value)}
            className="mt-1 h-9 w-full rounded-md border border-slate-700 bg-slate-950 px-2 text-xs text-slate-200"
          >
            {MODES.map((mode) => (
              <option key={mode} value={mode}>
                {modeLabelMap[mode] || mode}
              </option>
            ))}
          </select>
        </label>

        <button
          type="button"
          onClick={onValidate}
          disabled={validating || changing}
          className="h-9 rounded-md border border-cyan-500/45 bg-cyan-500/10 px-4 text-xs font-semibold text-cyan-200 disabled:opacity-50"
        >
          {validating ? 'Memvalidasi...' : 'Validasi'}
        </button>

        <button
          type="button"
          onClick={handleChangeMode}
          disabled={!canChange}
          className="h-9 rounded-md border border-emerald-500/45 bg-emerald-500/10 px-4 text-xs font-semibold text-emerald-200 disabled:opacity-40"
        >
          {changing ? 'Mengubah...' : 'Ubah Mode Rollout'}
        </button>
      </div>

      <div className="mt-3 rounded-lg border border-slate-800 bg-slate-950/70 p-3">
        <div className="flex items-center justify-between gap-2">
          <p className="text-xs text-slate-300">{getValidationSummaryText(validationResult)}</p>
          {validationResult?.readinessStatus ? <RolloutStatusBadge status={validationResult.readinessStatus} /> : null}
        </div>

        {Array.isArray(validationResult?.blockers) && validationResult.blockers.length ? (
          <ul className="mt-2 list-disc space-y-1 pl-4 text-xs text-red-300">
            {validationResult.blockers.map((item, idx) => <li key={`vb-${idx}`}>{item}</li>)}
          </ul>
        ) : null}

        {Array.isArray(validationResult?.warnings) && validationResult.warnings.length ? (
          <ul className="mt-2 list-disc space-y-1 pl-4 text-xs text-amber-300">
            {validationResult.warnings.map((item, idx) => <li key={`vw-${idx}`}>{item}</li>)}
          </ul>
        ) : null}
      </div>
    </section>
  );
};

export default RecoveryModeChangePanel;
